$( document ).ready(function() {
	$('.js_hmbanner').slick({
		arrows: true,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		horizontal: true,
		infinite: true,
		autoplay: true,
		fade: true,
		pauseOnHover: false,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 601,
				settings: {
					arrows: false,
					dots: false
				}
			}
		]
	});

	// // CLIENT REVIEW

    $('.client-slider').slick({
		arrows: true,
		dots: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		horizontal: true,
		infinite: true,
		autoplay: false,
		pauseOnHover: false,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: '20px',
				}
			}
		]
	});



	// Package pizza

	$(".product-slider").slick({
			arrows: true,
			dots: false,
			slidesToShow: 5,
			slidesToScroll: 1,
			horizontal: true,
			infinite: true,
			autoplay: false,
			pauseOnHover: false,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1440,
					settings: {
					slidesToShow: 4,

					}
				},
				{
					breakpoint: 1200,
					settings: {
					slidesToShow: 3,
					}
				},
				{
					breakpoint: 992,
					settings: {
					slidesToShow: 2,
					}
				},
			],
	  });


	// Gallery 
	$(".gallery-slider").slick({
			arrows: true,
			dots: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			horizontal: true,
			infinite: true,
			autoplay: false,
			pauseOnHover: false,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
					slidesToShow: 2,

					}
				},
				{
					breakpoint: 767,
					settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: '20px',
					}
				}
			]
	  });

	  


	  
	  // Party Equipment Hire
	$('.hm-party-euipment .equipment-item').slick({
        rows: 2,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
		autoplay:false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440, // mobile
                settings: {
                    slidesToShow: 3,   
                }
            },
			{
                breakpoint: 1200, // mobile
                settings: {
                    rows: 1,
                    slidesToShow: 2,   
                }
            },
			{
                breakpoint: 768, // mobile
                settings: {
                    rows: 1,
                    slidesToShow: 1,   
                }
            }
        ]
    });




	// Fancy box

	$("[data-fancybox]").fancybox({
	    // Options will go here
	    slideShow  : false,
	    fullScreen : false,
	    thumbs     : false,
	    closeBtn   : true,
	    slideShow  : true,
	});

});




$(document).on('afterClose.fb', function() {
	$('.gallery-slider').slick('refresh'); console.log("SDF");
});